import { Component, OnInit } from '@angular/core';
import { BlackboxService, BlackboxDto } from "../../shared/service-proxies/service-proxies";

@Component({
    selector: 'app-fetch-data',
    templateUrl: './fetch-data.component.html',
    standalone: false
})
export class FetchDataComponent implements OnInit  {
  public blackBoxes: BlackboxDto[];

  constructor(private blackboxService: BlackboxService) {
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    let bb = this.blackboxService.getAll().subscribe(data => {
      this.blackBoxes = data;
    }, error => {
      debugger;
    });
  }
}
